package com.evoapps.evoshift.spreadsheet

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberUpdatedState
import kotlinx.browser.document
import org.khronos.webgl.ArrayBuffer
import org.khronos.webgl.Int8Array
import org.w3c.dom.HTMLInputElement
import org.w3c.files.FileReader
import org.w3c.files.get

/** The browser's file chooser (a hidden file input for CSV and Excel files), opened by the click that asked for it. */
@Composable
internal actual fun rememberPlatformSpreadsheetFilePicker(onPicked: OnFilePicked): SpreadsheetFilePicker {
    val callback = rememberUpdatedState(onPicked)
    return remember {
        SpreadsheetFilePicker {
            val input = document.createElement("input") as HTMLInputElement
            input.type = "file"
            input.accept = ".csv,.tsv,.xlsx,.txt,text/csv,text/tab-separated-values,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            input.style.display = "none"
            input.onchange = {
                val file = input.files?.get(0)
                input.remove()
                if (file != null) {
                    val reader = FileReader()
                    reader.onload = {
                        val bytes = Int8Array(reader.result.unsafeCast<ArrayBuffer>()).unsafeCast<ByteArray>()
                        callback.value(PickedFile(file.name, bytes))
                    }
                    reader.onerror = { callback.value(null) }
                    reader.readAsArrayBuffer(file.slice(0, PICK_READ_LIMIT))
                }
            }
            input.addEventListener("cancel", { input.remove() })
            document.body?.appendChild(input)
            input.click()
        }
    }
}
